// extracted by mini-css-extract-plugin
export var childrenContainer = "_3k-0";
export var virtualScrollArea = "_3k-1";